/* Hide/show header on scroll (desktop only) */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;

    let prevScrollPos = window.pageYOffset;
    const navHeight = navigation.offsetHeight;
    const SCROLL_THRESHOLD = 50;

    window.addEventListener('scroll', function () {
        // Only affect on desktop (viewport width > 767px)
        if (window.innerWidth > 767) {
            const currentScrollPos = window.pageYOffset;
            const isScrollingDown = currentScrollPos > prevScrollPos;

            // Add/remove is-scrolled class when past threshold
            if (currentScrollPos > SCROLL_THRESHOLD) {
                navigation.classList.add('is-scrolled');
            } else {
                navigation.classList.remove('is-scrolled');
            }

            // Hide/show based on scroll direction
            if (!isScrollingDown) {
                // Scrolling UP - show nav
                navigation.style.top = '0';
            } else if (currentScrollPos > SCROLL_THRESHOLD) {
                // Scrolling DOWN - hide nav only after threshold
                navigation.style.top = `-${navHeight}px`;
            }

            prevScrollPos = currentScrollPos;
        }
    }, { passive: true });
})();

/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();